module.exports = __webpack_public_path__ + "img/establishmentRole.fd592c54.svg";